/*global window, jQuery */
(function($) {
   'use strict';


    $('.guarda_tutte').on('click', function(){
      $('.galleria_0').trigger('click');
    });

}(jQuery));